<div class="form-modal" data-e2e-id="form-modal" [ngClass]="{ 'not-scrollable': !isScrollable }">
  <!-- modal-header -->
  <div class="xux-modal-header modal-header" data-e2e-id="xux-modal-header">
    <div class="title-holder">
      <xux-icon
        data-e2e-id="close-modal-button"
        class="xux-icon-close"
        icon="icon-close"
        *ngIf="closeButtonInTitle"
        (click)="handleButtonClick(closeButtonInTitle.value)"
      ></xux-icon>
      <span data-e2e-id="modal-title" class="modal-title">{{ modalTitle$ | async |translate }}</span>
      <div *ngIf="modalSubTitle$ | async as modalSubTitle" class="modal-sub-title">
        {{ modalSubTitle | translate }}
      </div>
    </div>

    <xvi-toolbar
      class="pull-right"
      *ngIf="hasHeaderButtons"
      [click]="handleButtonClick"
      [buttons]="headerButtons"
    ></xvi-toolbar>
  </div>
  <!-- / modal-header -->

  <!-- modal-body -->
  <div data-e2e-id="xux-modal-body" class="xux-modal-body modal-body" [class.hide-sidebar]="hideSidebarCondition()">
    <div
      data-e2e-id="xux-modal-description"
      class="xux-modal-description"
      [class.add-paddings]="!form"
      *ngIf="options?.text"
      [innerHtml]="options?.text | safeHtml"
    ></div>
    <xux-schema-form
      *ngIf="!!form"
      [defaultWidgetFamily]="defaultWidgetFamily"
      [form]="form"
      [groups]="groups"
      [beforeChange]="beforeFormGroupChange"
      [groupIndexControl]="groupIndexControl"
      (onFormAction)="onFormAction($event)"
    ></xux-schema-form>
  </div>
  <!-- / modal-body -->

  <!-- modal-footer -->
  <div data-e2e-id="xux-modal-footer" class="xux-modal-footer">
    <div
      data-e2e-id="modal-error-block"
      class="col-sm-12 modal-error-block"
      *ngIf="(showPristineError || form?.dirty) && errorObs | async as error"
    >
      <div data-e2e-id="modal-alert-block" class="alert alert-warning alert-dismissable" role="alert">
        <p>
          <strong>{{ error.code | translate }}</strong> {{ error.message | translate }}
        </p>
      </div>
    </div>

    <div *ngIf="inlineLabelObs" class="col-sm-12 inline-label-container">
      <xvi-label
        *ngFor="let inlineLabel of inlineLabelObs | async"
        [title]="inlineLabel.widgetData.title"
        [titleObs]="inlineLabel.widgetData.titleObs"
        [itemClass]="inlineLabel.widgetData?.itemClass"
        [widgetData]="inlineLabel.widgetData"
        [textColor]="inlineLabel.widgetData?.textColor"
        [backgroundColor]="inlineLabel.widgetData?.backgroundColor"
      ></xvi-label>
    </div>

    <div *ngIf="!!footerButtons.length" data-e2e-id="toolbar-btns" class="toolbar-btns">
      <xvi-toolbar [click]="handleButtonClick" [buttons]="footerButtons"></xvi-toolbar>
    </div>
  </div>
  <!-- / modal-footer -->
</div>
<xux-loader-small
  *ngIf="showLoader"
  [background]="'transparent'"
  [cssScale]="0.75"
  [isLoaderVisible]="isLoading$ | async"
></xux-loader-small>
